import { SelectedDateState } from './selectedDateInterface';

export const selectedDateSliceName = 'selectedDateSlice';

export const selectedDateInitialStateValue: SelectedDateState = {
  date: '',
};
